<template>
  <page-container>
    <template v-slot:page-fixed-header>
      <v-skeleton-loader v-if="isSkeleton" type="heading"></v-skeleton-loader>
      <span
        class="text-h5 font-weight-bold ml-2 full-width page-header"
        v-else
        >{{ $t("menu.survey") }}</span
      >

      <v-spacer></v-spacer>
      <v-tabs :key="render"
        v-if="!isSkeleton"
        v-model="tab"
        class="a-tabs survey-tabs pt-3"
        height="38"
        style="background-color: var(--v-Neutral-base)"
        right
      >
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab key="question" tab-value="question" href="#question">
          {{ $t("poll.lblResponseByYou") }}
        </v-tab>
        <v-tab
          v-if="$security.checkUserAccess('ViewSurveyResponse')"
          key="response "
          tab-value="response"
          href="#response"
        >
          {{ $t("poll.lblResponseByRespondent") }}
        </v-tab>
        <v-tab
          v-if="$security.checkUserAccess('ViewSurveyResponse')"
          key="result"
          tab-value="result"
          href="#result"
        >
          <v-skeleton-loader
            v-if="isSkeleton"
            type="heading"
          ></v-skeleton-loader>
          <v-chip
            v-else
            class="ma-1 pl-2 pr-2"
            color="primary"
            text-color="white"
            x-small
          >
            {{ surveyResponseResult.length }}
          </v-chip>
          {{ $t("poll.lblResultSummary") }}
        </v-tab>
        <v-tab
          v-if="$security.checkUserAccess('ViewSurveyResponse')"
          key="result-summary"
          tab-value="result-summary"
          href="#result-summary"
        >
          +{{ $t("poll.lblResultSummary") }}
        </v-tab>
      </v-tabs>
      <v-tooltip v-if="!isSkeleton" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            @click="onclose()"
            v-bind="attrs"
            v-on="on"
            color="primaryDark"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("btnClose") }} </span>
      </v-tooltip>
    </template>
    <template v-slot:page-content>
      <SurveySelector v-if="tab == 'result-summary'"></SurveySelector>
      <v-card flat tile color="secondary" style="width: 100%">
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12" md="12" class="pa-0 ma-0">
              <v-skeleton-loader
                v-if="isSkeleton"
                type="table-heading, list-item"
              ></v-skeleton-loader>
             
              <survey-details-card
                v-else
                :surveyDetails="surveyData"
                :tab="tab"
              ></survey-details-card>

              <v-divider></v-divider>
              <v-skeleton-loader
                v-if="isSkeleton"
                type="article, divider, article, actions"
              ></v-skeleton-loader>
              <transition name="fade" mode="out-in" appear v-else>
                <div>
                <component
                  :is="dynamicTab"
                  :surveyQuestions="surveyResponseData"
                  :surveyDetails="surveyResponseData"
                  :isReadOnly="!isActive"
                  :key="`dynamic_tab_${tab}`"
                  :tab="tab"
                ></component>
                </div>
              </transition>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <tenant-switch-dialog ref="refSwitchDialog"></tenant-switch-dialog>
    </template>
  </page-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import PollQuestion from "./PollQuestion.vue";
import SurveyQuestions from "./SurveyQuestions.vue";
import SurveyResponse from "./SurveyResponse.vue";
import SurveyResult from "./SurveyResult.vue";
import SurveyDetailsCard from "./surveyDetailsCard.vue";
import SurveyQuestionsWithSection from "./SurveyQuestionsWithSections.vue";
import SurveyResponseWithSection from "./SurveyResponseWithSections.vue";
import SurveySelector from "./SurveySelector.vue";
import Vue from "vue";
import Loader from "@/components/Loader";

import {
  RichTextEditorPlugin,
  HtmlEditor,
} from "@syncfusion/ej2-vue-richtexteditor";
import TenantSwitchDialog from "../TenantSwitchDialog.vue";
import SignalRMixin from "../../mixin/SignalRMixin";
Vue.use(RichTextEditorPlugin);
export default {
  components: {
    SurveyDetailsCard,
    SurveyQuestions,
    PollQuestion,
    SurveyResponse,
    SurveyResult,
    SurveyQuestionsWithSection,
    SurveyResponseWithSection,
    TenantSwitchDialog,
    Loader,
    SurveySelector
  },
  name: "SurveyDetails",
  mixins: [SignalRMixin],
  provide: {
    richtexteditor: [HtmlEditor],
  },
  data() {
    return {
      render: 0,
      isSkeleton: false,
      tabRef: 0,
      tab: "question",
      statusColor: "",
      surveyStatus: "",
      showTenantDialog: false,
      routeTenantId: "",
      setSurveyResponse: null,
      setSurveySummaryResponse: null,
    };
  },
  watch: {
    '$i18n.locale': {
      immediate: true,
      async handler() {
        this.render++;
      }
    },
    async tab(value, oldTab) {
      try {
        if (value === "question") {
          await this.loadQuestionaireTab();
        } else if (value === "response") {
          if(this.$route.params.id)
          this.$root.$emit("reset-respondent");
        }
      } catch (error) {
        console.log(error, "survey details");
      }
    },
    async getSelectorSurvey(newValue, oldValue){
      if(newValue){
        await this.loadSurveySelectorData(newValue)
        this.$root.$emit("reset-respondent");
      }
    },
  },
  computed: {
    ...mapState({
      surveyDetails: (state) => state.poll.surveyDetails,
      surveySummaryDetails: (state) => state.poll.surveySummaryDetails,
      surveyResponseResult: (state) => state.poll.surveyResponseResult,
      surveyCompairResult: (state) => state.poll.surveyCompairResult,
      getSelectorSurvey: (state) => state.poll.selectorSurvey,
    }),
    LoaderText() {
      return this.$t("LoaderText");
    },
    surveyTitle() {
      return this.surveyData ? this.surveyData.title : "Loading...";
    },
    surveyDescription() {
      return this.surveyData ? this.surveyData.description : "";
    },
    surveyResponseData() {
      if(this.tab === "result-summary" && this.getSelectorSurvey){
        return this.setSurveySummaryResponse
      }
      return this.setSurveyResponse;
    },
    surveyData() {
      if(this.tab === "result-summary" && this.getSelectorSurvey){
        return this.surveySummaryDetails
      }
      return this.surveyDetails;
    },
    dynamicTab() {
      if (this.tab === "question") {
        if (this.isSectionWiseDisplay) {
          return this.surveyType === "survey"
            ? "SurveyQuestionsWithSection"
            : "";
        } else {
          return this.surveyType === "survey"
            ? "SurveyQuestions"
            : "PollQuestion";
        }
      } else if (
        this.tab === "result" || this.tab === "result-summary" &&
        this.$security.checkUserAccess("ViewSurveyResponse")
      ) {
        return this.isSectionWiseDisplay
          ? "SurveyResponseWithSection"
          : "SurveyResponse";
      } else if (
        this.tab === "response" &&
        this.$security.checkUserAccess("ViewSurveyResponse")
      ) {
        return "SurveyResult";
      }
    },
    isActive() {
      let startDate = new Date(this.surveyData.startDate);
      let endDate = new Date(this.surveyData.endDate);
      let today = new Date();
      if (this.surveyData.surveyParticipant) {
        const surveyParticipant = this.surveyData.surveyParticipant;
        if (
          !surveyParticipant.some(
            (item) => item.email === this.$auth.user.email
          )
        ) {
          return false;
        }
      }

      if (startDate > today) {
        return false;
      }
      if (endDate < today) {
        return false;
      }
      if (startDate <= today) {
        return true;
      }

      return false;
    },
    isSectionWiseDisplay() {
      if (!this.surveyData.sections) {
        return false;
      }
      if (this.surveyData.sections.length > 0) {
        return true;
      }

      return false;
    },
    surveyType() {
      if (this.surveyData) {
        return this.surveyData.type;
      }
      return "survey";
    },
    commentModel() {
      return {
        type: "Expand",
        enable: false,
      };
    },
    tenantId() {
      return sessionStorage.getItem("tenantId");
    },
  },
  mounted,
  methods: {
    ...mapActions({
      getSurveyById: "poll/getSurveyById",
      getSurveySummaryById: "poll/getSurveySummaryById",
      getSurveyResult: "poll/getSurveyResult",
      getResponseBySurveyId: "poll/getResponseBySurveyId",
      getSilentResponseBySurveyId: "poll/getSilentResponseBySurveyId",
      getResponseSummaryBySurveyId: "poll/getResponseSummaryBySurveyId",
      setSurveySelector: "poll/setSurveySelector",
      setDefaultCompairResult: "poll/setDefaultCompairResult",
      setDefaultDetails: "poll/setDefaultDetails",
    }),
    signalRInit,
    onclose,
    mount,
    loadQuestionaireTab,
    loadSurveySelectorData,
    loadSummaryQuestionaireTab,
    getExpiryDate(endDate) {
      var Xmas95 = new Date(endDate);
      var options = { dateStyle: "full", timeStyle: "short" };
      return new Intl.DateTimeFormat(this.selectedLang, options).format(Xmas95);
    },
  },
};
async function loadSurveySelectorData(surveyId){
  this.isSkeleton = true;
  if (this.$security.checkUserAccess("ViewSurveyPolls")) {
    try {
         const result = await this.getSurveySummaryById(surveyId);
      } catch (error) {
        console.log(error, "API error");
      }
    if (this.$security.checkUserAccess("ViewSurveyResponse")) {
      await this.getResponseSummaryBySurveyId(surveyId);
    }
  }
  await this.loadSummaryQuestionaireTab(surveyId);
  this.isSkeleton = false;
}
async function mounted() {
  const result = await this.$refs.refSwitchDialog.checkTenantName();
  if (!result) {
    this.isSkeleton = true;
    await this.mount();
    
    await this.loadQuestionaireTab();
  }
  this.isSkeleton = false;
}

async function mount() {
  const surveyId = this.$route.params.id;
  if (surveyId) {
    if (this.$security.checkUserAccess("ViewSurveyPolls")) {
      await this.getSurveyById(surveyId);
      if (this.$security.checkUserAccess("ViewSurveyResponse")) {
        await this.getResponseBySurveyId(surveyId);
        this.signalRInit(`surveys_${surveyId}`);
        this.setSurveySelector(surveyId)
      }
    }
  }
}

function signalRInit(target) {
  this.signalConnection.on(target, async (message) => {
    const result = JSON.parse(message);
    if (result) {
      if (this.$security.checkUserAccess("ViewSurveyResponse")) {
        await this.getSilentResponseBySurveyId(this.$route.params.id);
        if (this.tab === "question" && this.$auth.user.email === result.userid) {
         await this.loadQuestionaireTab();
        }
      }
      
      this.$root.$emit("refresh-signalR");
    }
  });
  if (this.signalConnection.connectionState.toLowerCase() === "disconnected") {
    this.signalConnection.start().catch();
  }
}

async function loadQuestionaireTab() {
  const surveyId = this.$route.params.id;
 
  const { tenantUserName: userId } = this.$auth.user;

  // Check access and valid survey ID
  if (!this.$security.checkUserAccess("ViewSurveyPolls") || !surveyId) {
    return; // Exit early if no access or invalid survey ID
  }
  const surveyResDetails = _.cloneDeep(this.surveyDetails);

  const params = { surveyid: surveyId, userid: userId };
  const result = await this.getSurveyResult(params);

  surveyResDetails.questions.forEach((question) => {
    const answerObj = result?.questionAnswers?.find(
      (answer) => answer.questionId === question.id
    );
    question.selectedAnswer = answerObj?.answer ?? null;
  });
  this.setSurveyResponse = surveyResDetails;
}

async function loadSummaryQuestionaireTab(surveyId) {
  const { tenantUserName: userId } = this.$auth.user;
  // Check access and valid survey ID
  if (!this.$security.checkUserAccess("ViewSurveyPolls") || !surveyId) {
    return; // Exit early if no access or invalid survey ID
  }
  const surveyResDetails = _.cloneDeep(this.surveySummaryDetails);

  const params = { surveyid: surveyId, userid: userId };
  const result = await this.getSurveyResult(params);

  surveyResDetails.questions.forEach((question) => {
    const answerObj = result?.questionAnswers?.find(
      (answer) => answer.questionId === question.id
    );
    question.selectedAnswer = answerObj?.answer ?? null;
  });
  this.setSurveySummaryResponse = surveyResDetails;
}
async function onclose() {
  switch (this.$route.params.origin) {
    case "dashboard":
      this.$router.push("/dashboard");
      break;
    case "survey":
      this.$router.push("/survey");
      break;
    case "search":
      this.$router.push("/search");
      break;
    case "calendar":
      this.$router.push("/calendar");
      break;
    default:
      this.$router.push("/");
      break;
  }
}
</script>

<style scoped>
.survey-tabs .v-tab--active {
  background: #dde3ee;
}
.survey-tabs .v-tab {
  min-width: 230px;
}
::v-deep .descriptionText {
  opacity: 0.7 !important;
  background-color: var("--v-appBarT-base") !important;
}

::v-deep .e-richtexteditor:not(.e-rte-toolbar-enabled) .e-rte-content {
  background-color: var("--v-appBarT-base") !important;
  border: none !important;
  color: black;
}

::v-deep .e-richtexteditor:not(.e-rte-toolbar-enabled) {
  border: none !important;
  background-color: var("--v-appBarT-base") !important;
}
.basil {
  background-color: #e1efff !important;
}
.basil--text {
  color: white !important;
}
.title-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
